
import {createSlice} from "@reduxjs/toolkit";

export const contractDrilldownSliceCDPV = createSlice({
    name: 'contractDrilldownSlcCDPV',
    initialState: {value: { cdpvGridState: false, cdpvGridRefresh: false}},
    reducers:
        {
            changeContractDrilldownCDPV: (state, action) => {
                state.value = {
                    ...state.value,  // Keep existing fields
                    ...action.payload // Merge new values
                };
            }
        }
});

export const { changeContractDrilldownCDPV } = contractDrilldownSliceCDPV.actions;

export default  contractDrilldownSliceCDPV.reducer ;
